// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"app-components-beat-beatlist--list","heading":"app-components-beat-beatlist--heading"};